import Vue from 'vue'

export const vueApp = new Vue({
	el:'#dropdown-app',
	data () {
		return {
			subjectsOpen: false,
			demographicsOpen: false,
			mediaOpen: false
		}
	},
	methods: {
		toggleSubjectsOpen() {
			this.subjectsOpen = !this.subjectsOpen
			this.demographicsOpen = false
			this.mediaOpen = false
		},
		toggleDemographicsOpen() {
			this.subjectsOpen = false
			this.demographicsOpen = !this.demographicsOpen
			this.mediaOpen = false
		},
		toggleMediaOpen() {
			this.subjectsOpen = false
			this.demographicsOpen = false
			this.mediaOpen = !this.mediaOpen
		}
	}
})
